import {Component, DestroyRef, OnDestroy, OnInit} from '@angular/core';
import {NgClass} from '@angular/common';
import {PlanModelService} from '../../common/service/plan-model.service';
import {LookupService} from '../../common/service/lookup.service';
import {NgEventBus} from 'ng-event-bus';
import {PlanLodgementType} from '../../common/models/plan-lodgement-type.model';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {PermissionsService} from '../../common/service/permissions.service';
import {Subscription} from 'rxjs';
import {NlrFormFieldHasErrorPipe} from '../../common/pipe/nlr-form-field-has-error.pipe';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'plan-amendment',
    imports: [NgClass, FormsModule, NlrFormFieldHasErrorPipe],
    templateUrl: './plan-amendment.component.html',
    styleUrl: './plan-amendment.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class PlanAmendmentComponent implements OnInit, OnDestroy {
    permissions = ['EDIT_CERTIFICATION', 'VIEW_CERTIFICATION'];

    title = 'Plan amendment';

    planLodgementTypes: PlanLodgementType[] = [];

    selectedPlanLodgementType: PlanLodgementType;

    initiatePlanAmendmentSubscription: Subscription;

    constructor(
        private eventBus: NgEventBus,
        private permissionsService: PermissionsService,
        private lookupService: LookupService,
        private planModelService: PlanModelService,
        private destroyRef: DestroyRef
    ) {}

    ngOnInit(): void {
        this.planLodgementTypes = this.lookupService.getLookups('planLodgementType');

        this.initiatePlanAmendmentSubscription = this.eventBus
            .on('nlr:initiate-plan-amendment')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                const model = this.getPlanModel();
                if (model.lodgementType?.value && this.planLodgementTypes) {
                    const lodgementTypeCode = model.lodgementType.value.toUpperCase();
                    const selectedPlanLodgementType = this.planLodgementTypes.find(planLodgementType => planLodgementType.code === lodgementTypeCode);
                    if (selectedPlanLodgementType) {
                        this.selectedPlanLodgementType = selectedPlanLodgementType;
                    }
                }
            });
    }

    ngOnDestroy() {
        this.initiatePlanAmendmentSubscription.unsubscribe();
    }

    getPlanModel() {
        return this.planModelService.getModel();
    }

    showAmendmentDetails(): boolean {
        return !!this.selectedPlanLodgementType?.amendmentDescriptionLabel && this.permissionsService.hasPermission(this.permissions);
    }

    isAmendmentDescriptionDisabled(): boolean {
        return this.planModelService.readonly || !this.permissionsService.hasEditPermission(this.permissions);
    }
}
